module.exports = vendor_6f81d7070e61a718cd5c;